module.exports = __webpack_public_path__ + "img/TDSouthAfrica-white-new.6e88adb4.png";